import { 
  ATTR_STATUS, 
  ATTR_LAST_EDITED_TIME,
  ATTR_LAST_EDITED_TIME_STR,
  ATTR_SME_VERIFIED,
  VAL_STATUS_APPROVED,
  VAL_STATUS_AWAITING_APPROVAL,
 } from "../constants.js";

const getDateInMs = (d) => {
  let secOrMillisec = d;
  if (Math.abs(Date.now() - secOrMillisec) > Math.abs(Date.now() - secOrMillisec * 1000)) {
    secOrMillisec *= 1000;
  }
  return secOrMillisec;
}

const getDateDisplayStr = (d) => {
  try {
    const date = new Date(d);
    const str = date.toLocaleDateString("en-US", { day: 'numeric' }) + 	" " + 
      date.toLocaleDateString("en-US", { month: 'short' }) + 	", " + 
      date.toLocaleDateString("en-US", { year: 'numeric' });
    return str;
  }
  catch (error) {}
}

const entityTransformer = (entityData) => {

  const entity = { ...entityData };

  // Ensure date fields are in milliseconds and add date display strings
  if (entity[ATTR_LAST_EDITED_TIME]) {
    entity[ATTR_LAST_EDITED_TIME] = getDateInMs(entity[ATTR_LAST_EDITED_TIME]);
    entity[ATTR_LAST_EDITED_TIME_STR] = getDateDisplayStr(entity[ATTR_LAST_EDITED_TIME]);
  }

  // Decorate with SME verified status
  const smev = (entity[ATTR_STATUS] === VAL_STATUS_APPROVED) 
    || (entity[ATTR_STATUS] === VAL_STATUS_AWAITING_APPROVAL);
  entity[ATTR_SME_VERIFIED] = smev;

  // Return transformed entity
  return entity;

}

export default entityTransformer;